/* House of Ovelle — "your diffuser needs a fragrance" prompt.
   Fires once per session, after an add, when the bag holds a diffuser and no oil.
   Markup is built here and appended to <body> so the cart drawer can re-render
   itself underneath without destroying the dialog.

   Scents are multi-select: any number of the tiles can be chosen and they are
   added in one request. Size is one shared choice applied to every scent picked
   (matched by variant title, falling back to that scent's own default). */

/* Dawn declares PUB_SUB_EVENTS with `const`, so it is a global binding but NOT a
   property of window — every `window.PUB_SUB_EVENTS` guard in the theme silently
   fails. This file is deferred and sits in the footer group, so it runs after
   pubsub.js and before ovelle.js: mirroring the binding here repairs those
   guards for the whole theme as well as this one. */
if (typeof PUB_SUB_EVENTS !== 'undefined' && !window.PUB_SUB_EVENTS) window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;

(function () {
  var dataEl = document.getElementById('ov-oil-prompt-data');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!DATA.products || !DATA.products.length) return;

  var EVENTS = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null;
  var SEEN_KEY = 'ov-oil-prompt-seen';
  var TRADE = /trade/i;
  var DIFFUSER = /diffuser/i;
  var OIL = /fragrance oil|discovery set/i;

  function fmt(cents) {
    if (window.ovelleFormatMoney) return window.ovelleFormatMoney(cents);
    var f = window.ovelleMoneyFormat || '${{amount}}';
    return f
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, (cents / 100).toFixed(0))
      .replace(/<[^>]+>/g, '');
  }

  /* Subscription apps often name every frequency the same ("Monthly Subscription"),
     so derive the label from the plan option value ("2MONTH…") when we can. */
  function frequencyLabel(p) {
    var m = /^(\d+)\s*(DAY|WEEK|MONTH|YEAR)/i.exec(p.opt || '') ||
            /every\s+(\d+)\s*(day|week|month|year)/i.exec(p.desc || '');
    if (!m) return (p.name || '').trim() || 'Every delivery';
    var n = +m[1], unit = m[2].toLowerCase();
    return n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
  }

  function sellableVariants(product) {
    return (product.variants || []).filter(function (v) {
      return v.available && !TRADE.test(v.title);
    });
  }

  /* One frequency list for the whole dialog, keyed by selling plan group so the
     same choice can be applied to whichever scents and size are picked. */
  function buildFrequencies() {
    var seen = {}, out = [];
    DATA.products.forEach(function (p) {
      sellableVariants(p).forEach(function (v) {
        (v.plans || []).forEach(function (plan) {
          if (!plan.group || seen[plan.group]) return;
          seen[plan.group] = true;
          out.push({ group: plan.group, label: frequencyLabel(plan) });
        });
      });
    });
    return out;
  }

  var FREQUENCIES = buildFrequencies();
  var state = {
    selected: [],
    sizeTitle: null,
    subscribe: !!DATA.subscribe_default && FREQUENCIES.length > 0,
    group: null,
    open: false
  };

  (function pickDefaultFrequency() {
    var want = (DATA.frequency_match || '').toLowerCase();
    var match = FREQUENCIES.filter(function (f) { return f.label.toLowerCase().indexOf(want) > -1; })[0];
    state.group = (match || FREQUENCIES[0] || {}).group || null;
  })();

  function defaultVariant(product) {
    var vs = sellableVariants(product);
    if (!vs.length) return null;
    var want = (DATA.default_size || '').toLowerCase();
    var match = vs.filter(function (v) { return v.title.toLowerCase().indexOf(want) > -1; })[0];
    return match || vs[Math.min(1, vs.length - 1)];
  }

  /* The shared size is held as a title so it can be resolved per scent; a scent
     that does not stock it falls back to its own default rather than dropping out. */
  function variantFor(product) {
    var vs = sellableVariants(product);
    if (!vs.length) return null;
    if (state.sizeTitle) {
      var match = vs.filter(function (v) { return v.title === state.sizeTitle; })[0];
      if (match) return match;
    }
    return defaultVariant(product);
  }

  function sizeSource() {
    return state.selected[0] || DATA.products[0];
  }

  function planFor(variant) {
    if (!variant || !state.subscribe) return null;
    var plans = variant.plans || [];
    return plans.filter(function (p) { return p.group === state.group; })[0] || plans[0] || null;
  }

  function chosen() {
    return state.selected.map(function (p) {
      var v = variantFor(p);
      return v ? { product: p, variant: v, plan: planFor(v) } : null;
    }).filter(Boolean);
  }

  function total() {
    return chosen().reduce(function (sum, row) {
      return sum + (row.plan ? row.plan.price : row.variant.price);
    }, 0);
  }

  function isSelected(product) {
    return state.selected.indexOf(product) > -1;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- markup ---------------- */
  var root = null;

  function build() {
    var c = DATA.copy || {};
    root = document.createElement('div');
    root.className = 'ov-oilprompt';
    root.style.setProperty('--ov-cols', Math.min(4, DATA.products.length));
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="ov-oilprompt__overlay" data-ov-oilprompt-dismiss></div>' +
      '<div class="ov-oilprompt__sheet" role="dialog" aria-modal="true" aria-labelledby="ov-oilprompt-title">' +
        '<button type="button" class="ov-oilprompt__close" data-ov-oilprompt-dismiss aria-label="Close">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.3" fill="none"/></svg>' +
        '</button>' +
        '<header class="ov-oilprompt__head">' +
          (c.eyebrow ? '<span class="ov-oilprompt__eyebrow"></span>' : '') +
          '<h2 class="ov-oilprompt__title" id="ov-oilprompt-title"></h2>' +
          '<p class="ov-oilprompt__text"></p>' +
        '</header>' +
        '<div class="ov-oilprompt__scents" data-ov-scents role="group" aria-label="Choose your scents"></div>' +
        '<div class="ov-oilprompt__sizes" data-ov-sizes></div>' +
        '<div class="ov-oilprompt__sub" data-ov-sub hidden>' +
          '<button type="button" class="ov-oilprompt__switch" data-ov-sub-toggle role="switch" aria-checked="false">' +
            '<span class="ov-oilprompt__switch-dot"><svg viewBox="0 0 12 10" width="10" height="9" aria-hidden="true"><path d="M1 5l3.2 3.2L11 1.4" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '</button>' +
          '<div class="ov-oilprompt__sub-body">' +
            '<span class="ov-oilprompt__sub-title"></span>' +
            '<span class="ov-oilprompt__sub-freq"><select data-ov-freq aria-label="Delivery frequency"></select></span>' +
            '<span class="ov-oilprompt__sub-note"></span>' +
          '</div>' +
        '</div>' +
        '<footer class="ov-oilprompt__foot">' +
          '<button type="button" class="ov-oilprompt__add" data-ov-oilprompt-add></button>' +
          '<button type="button" class="ov-oilprompt__skip" data-ov-oilprompt-dismiss></button>' +
        '</footer>' +
      '</div>';

    if (c.eyebrow) root.querySelector('.ov-oilprompt__eyebrow').textContent = c.eyebrow;
    root.querySelector('.ov-oilprompt__title').textContent = c.title || 'Add a fragrance';
    root.querySelector('.ov-oilprompt__text').textContent = c.text || '';
    root.querySelector('.ov-oilprompt__sub-title').textContent = c.sub_title || 'Subscribe & Save';
    root.querySelector('.ov-oilprompt__sub-note').textContent = c.sub_note || '';
    root.querySelector('.ov-oilprompt__skip').textContent = c.skip || 'No thanks';

    var freq = root.querySelector('[data-ov-freq]');
    freq.innerHTML = FREQUENCIES.map(function (f) {
      return '<option value="' + escapeHtml(f.group) + '">' + escapeHtml(f.label) + '</option>';
    }).join('');
    if (state.group) freq.value = state.group;
    freq.addEventListener('change', function () { state.group = freq.value; render(); });

    root.querySelector('[data-ov-sub-toggle]').addEventListener('click', function () {
      state.subscribe = !state.subscribe;
      render();
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ov-oilprompt-dismiss]')) { close(); return; }

      var scent = e.target.closest('[data-ov-scent]');
      if (scent) {
        var product = DATA.products[+scent.dataset.ovScent];
        var at = state.selected.indexOf(product);
        if (at > -1) state.selected.splice(at, 1);
        else state.selected.push(product);
        render();
        return;
      }

      var size = e.target.closest('[data-ov-size]');
      if (size) {
        state.sizeTitle = size.dataset.ovSize;
        render();
        return;
      }

      if (e.target.closest('[data-ov-oilprompt-add]')) add();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) close();
    });

    document.body.appendChild(root);
  }

  /* Tiles and chips are built once and then updated in place: re-rendering the
     whole list on every toggle threw keyboard focus back to the body, which made
     picking several scents in a row unusable. */
  var sizeKey = null;

  function buildScents() {
    root.querySelector('[data-ov-scents]').innerHTML = DATA.products.map(function (p, i) {
      return '<button type="button" class="ov-oilprompt__scent" data-ov-scent="' + i + '" aria-pressed="false">' +
        (p.image ? '<span class="ov-oilprompt__scent-media"><img src="' + escapeHtml(p.image) + '" alt="" loading="lazy"></span>' : '') +
        '<span class="ov-oilprompt__scent-name">' + escapeHtml(p.title) + '</span>' +
        (p.notes ? '<span class="ov-oilprompt__scent-notes">' + escapeHtml(p.notes) + '</span>' : '') +
        '</button>';
    }).join('');
  }

  function buildSizes(options) {
    root.querySelector('[data-ov-sizes]').innerHTML = options.map(function (v) {
      return '<button type="button" class="ov-oilprompt__size" data-ov-size="' + escapeHtml(v.title) + '" aria-pressed="false">' +
        '<span class="ov-oilprompt__size-name">' + escapeHtml(v.title) + '</span>' +
        '<span class="ov-oilprompt__size-price" data-ov-size-price></span>' +
        '</button>';
    }).join('');
  }

  function render() {
    var scentsEl = root.querySelector('[data-ov-scents]');
    if (!scentsEl.children.length) buildScents();
    [].forEach.call(scentsEl.children, function (btn) {
      var on = isSelected(DATA.products[+btn.dataset.ovScent]);
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var options = sellableVariants(sizeSource());
    var key = options.map(function (v) { return v.title; }).join('|');
    if (key !== sizeKey) { sizeKey = key; buildSizes(options); }

    if (state.sizeTitle && !options.some(function (v) { return v.title === state.sizeTitle; })) {
      state.sizeTitle = null;
    }
    if (!state.sizeTitle) {
      var d = defaultVariant(sizeSource());
      state.sizeTitle = d ? d.title : null;
    }

    // The chip price is only shown when every chosen scent agrees on it, so a
    // mixed basket never advertises a number that is wrong for half of it.
    [].forEach.call(root.querySelector('[data-ov-sizes]').children, function (btn) {
      var title = btn.dataset.ovSize;
      var on = title === state.sizeTitle;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');

      var prices = state.selected.map(function (p) {
        var m = sellableVariants(p).filter(function (x) { return x.title === title; })[0];
        if (!m) return null;
        var pl = state.subscribe ? (m.plans || []).filter(function (x) { return x.group === state.group; })[0] : null;
        return { now: pl ? pl.price : m.price, was: m.price, discounted: !!pl };
      }).filter(Boolean);
      var agree = prices.length > 0 && prices.every(function (x) { return x.now === prices[0].now; });
      btn.querySelector('[data-ov-size-price]').innerHTML = agree
        ? (prices[0].discounted ? '<s>' + fmt(prices[0].was) + '</s> ' : '') + fmt(prices[0].now)
        : '';
    });

    var rows = chosen();
    var subRow = root.querySelector('[data-ov-sub]');
    var hasPlans = rows.some(function (r) { return (r.variant.plans || []).length > 0; });
    subRow.hidden = !rows.length || !hasPlans;
    // Only give up on subscribing when something IS picked and none of it can be
    // subscribed to — clearing the tiles must not quietly switch the toggle off.
    if (rows.length && !hasPlans) state.subscribe = false;
    root.querySelector('[data-ov-sub-toggle]').setAttribute('aria-checked', state.subscribe ? 'true' : 'false');
    subRow.classList.toggle('is-on', state.subscribe);

    var add = root.querySelector('[data-ov-oilprompt-add]');
    var label = (DATA.copy && DATA.copy.add) || 'Add to bag';
    if (!rows.length) {
      add.textContent = (DATA.copy && DATA.copy.empty) || 'Choose a scent';
      add.disabled = true;
    } else {
      add.disabled = false;
      add.textContent = (rows.length > 1 ? 'Add ' + rows.length + ' scents' : label) + ' — ' + fmt(total());
    }
  }

  function open() {
    if (!root) build();
    state.selected = DATA.products.length ? [DATA.products[0]] : [];
    state.sizeTitle = null;
    render();
    root.removeAttribute('hidden');
    // requestAnimationFrame never fires in a background tab, which would leave the
    // dialog un-opened and its full-screen layer swallowing clicks. Flush instead.
    void root.offsetWidth;
    root.classList.add('is-open');
    state.open = true;
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    var focusable = root.querySelector('[data-ov-scent]');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    state.open = false;
    setTimeout(function () { if (!state.open) root.setAttribute('hidden', ''); }, 260);
  }

  function add() {
    var rows = chosen();
    if (!rows.length) return;
    var btn = root.querySelector('[data-ov-oilprompt-add]');

    var items = rows.map(function (r) {
      var item = { id: r.variant.id, quantity: 1 };
      if (r.plan) item.selling_plan = r.plan.id;
      return item;
    });

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (res.status) { btn.textContent = res.description || res.message || 'Something went wrong'; return; }
        window.ovelleJustAdded = items[0].id;
        if (window.ovelleToast) {
          window.ovelleToast('Added to bag · ' + (rows.length > 1 ? rows.length + ' scents' : rows[0].product.title));
        }
        if (typeof publish === 'function' && EVENTS) {
          publish(EVENTS.cartUpdate, { source: 'ovelle-oil-prompt', productVariantId: items[0].id, cartData: res });
        }
        close();
        if (cart && cart.renderContents) cart.renderContents(res);
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }

  /* ---------------- trigger ---------------- */
  function seen() {
    try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; }
  }

  function maybeOpen() {
    if (seen() || state.open) return;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return;
        var hasDiffuser = items.some(function (i) { return DIFFUSER.test(i.product_type || ''); });
        var hasOil = items.some(function (i) {
          return OIL.test(i.product_type || '') || /discovery set/i.test(i.variant_title || '');
        });
        if (hasDiffuser && !hasOil) setTimeout(open, 450);
      })
      .catch(function () {});
  }

  window.ovelleOilPrompt = { open: open, close: close, check: maybeOpen };

  if (typeof subscribe === 'function' && EVENTS) {
    subscribe(EVENTS.cartUpdate, function (evt) {
      var src = (evt && evt.source) || '';
      if (src === 'ovelle-oil-prompt' || src === 'cart-items') return; // our own add, or a quantity change
      maybeOpen();
    });
  }
})();
